import { Fragment, memo } from 'react';
import Accountholder from './accountholder';
import Applicant from '../shared/applicant';
import Payment from '../shared/fragment-payment';
import { __PERSON_API_URL__ } from 'shell/constants/environment';

interface AuthenticFormProps {
  disabled?: boolean;
}

const AuthenticFormComponent = ({ disabled }: AuthenticFormProps): React.ReactElement => {
  return (
    <Fragment>
      <Payment />
      <Applicant
        disabled={disabled}
        hasAccountholder={false}
        isAuthentic
        url={`${__PERSON_API_URL__}/persona`}
      />
      <Accountholder isAuthentic />
    </Fragment>
  );
};

AuthenticFormComponent.displayName = 'Authentic Form component';

const AuthenticForm = memo(AuthenticFormComponent);

export default AuthenticForm;
